import cn from 'classnames'
import { HTMLProps, PointerEventHandler, useRef } from 'react'
import { ClientOnly, getRouteApi } from '@tanstack/react-router'
import { LineSmall, LineSmallFallback } from '~/components/data-display/charts/LineSmall'

export function HomepageHeaderMarketCap ({ className }: HTMLProps<HTMLDivElement>)
{
    const { stats } = getRouteApi('/').useLoaderData()
    const mcap30d: [Date, number][] = Object.entries(stats.totalMarketCap).sort((a, b) =>
    {
        let leftD = new Date(a[0])
        let rightD = new Date(b[0])
        const d = new Date()

        if (isNaN(leftD.getTime())) {
            leftD = d
        }

        if (isNaN(rightD.getTime())) {
            rightD = d
        }

        return leftD.getTime() - rightD.getTime()
    }).map((
        (item) =>
        {
            let d = new Date(item[0])
            if (isNaN(d.getTime())) {
                d = new Date()
            }

            return [d, item[1].marketCapMin]
        }
    ))

    // const activeButton = useRef<HTMLButtonElement>(null)
    // const onPointerDown: PointerEventHandler<HTMLButtonElement> = (evt) =>
    // {
    //     const active = activeButton.current
    //     const btn = evt.currentTarget
    //     if (active) {
    //         active.ariaPressed = 'false'
    //     }
    //     btn.ariaPressed = 'true'
    //     activeButton.current = btn
    // }

    return (
        <div
            className={cn(
                className,
                'flex flex-col justify-between items-stretch gap-2',
                'md:grid md:grid-cols-[max-content_max-content] md:justify-center md:gap-3',
            )}
        >
            <MarketCapCard
                className={cn(
                    'h-full flex flex-row items-center justify-between gap-2',
                    'md:flex-col md:items-start',
                    'lg:max-w-32',
                )}
            >
                <h3 className={'text-base/[1.125] font-medium uppercase'}>
                    <span aria-hidden={true}>[</span>Privacy dominance<span aria-hidden={true}>]</span></h3>
                <p className={cn('text-lg font-semibold text-start', 'md:text-3xl')}>{stats.marketCap?.relative}%</p>
            </MarketCapCard>

            <MarketCapCard className={cn('h-full flex flex-col justify-between gap-2')}>
                <div className={cn('flex flex-row justify-between items-top gap-2 text-base/[1.125]')}>
                    <h3 className={'font-medium uppercase'}>
                        <span aria-hidden={true}>[</span>Privacy market cap chart<span aria-hidden={true}>]</span>
                    </h3>

                    <p>30D</p>
                </div>
                {/*<span className={'btn btn-dash btn-accent btn-xs me-auto pointer-events-none'}>30d</span>*/}
                {/*<ChartToggle aria-pressed={false} className={cn('me-auto')}>30d</ChartToggle>*/}
                {/*<ul className={cn('flex flex-row items-center gap-2 flex-wrap')}>*/} {/*    <li>*/} {/*        <ChartToggle*/} {/*            onPointerDown={onPointerDown}*/} {/*            aria-pressed={true}*/} {/*            ref={activeButton}*/} {/*        >All</ChartToggle>*/} {/*    </li>*/} {/*    <li>*/} {/*        <ChartToggle onPointerDown={onPointerDown}>1M</ChartToggle>*/} {/*    </li>*/} {/*    <li>*/} {/*        <ChartToggle onPointerDown={onPointerDown}>1W</ChartToggle>*/} {/*    </li>*/} {/*    <li>*/} {/*        <ChartToggle onPointerDown={onPointerDown}>1D</ChartToggle>*/} {/*    </li>*/} {/*</ul>*/}
                <div className={cn('w-full h-18', 'md:w-63')}>
                    <ClientOnly fallback={<LineSmallFallback data={mcap30d} className={cn('w-full h-full')} />}>
                        <LineSmall
                            data={mcap30d}
                            className={cn('w-full h-full')}
                        /> </ClientOnly>
                </div>
            </MarketCapCard>
        </div>
    )
}

function MarketCapCard ({
    className,
    children,
}: HTMLProps<HTMLDivElement>)
{
    return (
        <div
            className={cn(
                className,
                'px-4 py-3 rounded-lg border border-solid border-accent/20',
                'md:px-3 md:py-2 md:border-dashed',
            )}
        >
            {children}
        </div>
    )
}

function ChartToggle ({
    className,
    children,
    'aria-pressed': ariaPressed = false,
    onPointerDown,
    ref,
}: HTMLProps<HTMLButtonElement>)
{
    return (
        <button
            className={cn(
                className,
                'grid place-content-center',
                'h-5.5 min-w-12.5 px-3',
                'md:h-3.5 md:min-w-7 md:px-2',
                'text-xs text-accent/40 uppercase',
                'border border-dashed border-accent/40',
                'aria-pressed:bg-radial from-transparent from-25% to-accent/40',
            )}
            aria-pressed={ariaPressed}
            onPointerDown={onPointerDown}
            ref={ref}
        >{children}
        </button>
    )
}